module.exports = __webpack_public_path__ + "static/media/p1.a16b8149.webp";


//////////////////
// WEBPACK FOOTER
// ./src/views/products/artist/assets/p1.webp
// module id = 260
// module chunks = 0